import { render, staticRenderFns } from "./NotFoundView.vue?vue&type=template&id=0bc34a26&scoped=true"
import script from "./NotFoundView.vue?vue&type=script&lang=js"
export * from "./NotFoundView.vue?vue&type=script&lang=js"
import style0 from "./NotFoundView.vue?vue&type=style&index=0&id=0bc34a26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc34a26",
  null
  
)

export default component.exports